var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
    opId:113,
    name:"删除操作的具体数据",
    parentId:"LOG_ID",
    parentName:"删除的操作日志",
    parentPath:"/system/delLog",
    dataClass:2,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }